export const categoriesByEnt = (builder) => ({
    categoriesByEnt: builder.mutation({
      query: ({ user_id, has_registered_by_super_admin, country}) => {
        const token = JSON.parse(localStorage.getItem('TOKEN'))?.token || '';
        return {
          url: `/template_categories/${country}`,
          method: 'GET',
          params: { user_id, has_registered_by_super_admin },
          headers: {
            'Content-Type': 'application/json',
            'Authorization': token
          },
        };
      },
    }),
  });
  